export default __webpack_public_path__ + "static/media/Minimise.57293bfa.svg";